
export const FETCH_ACCOUNT = 'FETCH_ACCOUNT';
export const FETCH_ACCOUNTS = 'FETCH_ACCOUNTS';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';



// WEBPACK FOOTER //
// ./src/data/accounts/types.js